export const CHANGE_LANGUAGE = 'preferences/change-language';
export const SET_IS_SWITCHING_LANGUAGE = 'preferences/set-is-switching-language';
